'use strict';
import { Injectable} from 'ng-metadata/core';

export const DEFAULT_SEARCH_OPERATOR : string = 'contains';

@Injectable()
export class SearchBarService {
        
    private _autoCompleteItems:any;
    private _showSignIn = false;
    private _acTriggered = false;

    constructor(){}

    get autoCompleteItems() {
        return this._autoCompleteItems;
    }
    
    set autoCompleteItems(autoCompleteItems) {
        this._autoCompleteItems = autoCompleteItems;
    }

    get showSignIn() {
        return this._showSignIn;
    }

    get acTriggered(): boolean {
        return this._acTriggered;
    }

    set acTriggered(value: boolean) {
        this._acTriggered = value;
    }

    setShowSignIn(showSignIn) {
        this._showSignIn = showSignIn;
    }

    public isAdvancedCollapsed(query, switchedFromSimpleToAdvanced) {
		if(query && !switchedFromSimpleToAdvanced){
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/searchBar.service.ts